module.exports = __webpack_public_path__ + "static/media/bg_mountain.8479a727.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/aboutme/bg_mountain.jpg
// module id = 57
// module chunks = 0